module.exports = "/_next/static/images/87237aaba79c224b472b5a7825a8ae9e-instant-pay.jpg.webp";